import React, { useEffect, useState } from "react";
import PieGraph from "../svg-graphs/PieGraph";
import { getPopularMenu } from "../../utils/dataFetch";

export default function PopularMenu() {
    const [error, setError] = useState("");
    const [popularMenu, setPopularMenu] = useState({ lastMonth: [] });

    useEffect(() => {
        const fetchPopularMenu = async () => {
            try {
                const result = await getPopularMenu();
                setPopularMenu(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchPopularMenu();
    }, []);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Популярні страви</h5>
                {error && (
                    <div className="alert alert-danger rounded-5 m-auto">
                        {error}
                    </div>
                )}
                {!error && (
                    <>
                        <div className="mt-3">
                            <PieGraph
                                inputData={popularMenu.lastMonth}
                                legendLabels={["Кількість"]}
                                rowLabel={"Назва"}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
